<div class="tw-flex tw-flex-col tw-gap-5 md:tw-h-full md:tw-w-full">
  <!-- Page header -->
  <div class="tw-flex tw-flex-col tw-gap-1 md:tw-hidden">
    <h1 class="tw-m-0 tw-text-2xl tw-font-semibold tw-text-color-text-default">
      {{ "advancedFeatures" | i18n }}
    </h1>
    <p class="tw-m-0 tw-text-[14px] tw-text-color-text-secondary">
      {{ "advancedFeaturesSubtitle" | i18n }}
    </p>
  </div>

  <!-- About -->
  <div class="tw-rounded-xl tw-bg-color-surface-card tw-p-5 tw-shadow-elevation-card">
    <p
      class="tw-mb-4 tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
    >
      {{ "about" | i18n }}
    </p>
    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b tw-border-color-border-subtle tw-py-2.5 tw-text-[13px]"
    >
      <span class="tw-text-color-text-secondary">{{ "appVersion" | i18n }}</span>
      <span class="tw-font-mono tw-text-color-text-default">{{ version }}</span>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-py-2.5 tw-text-[13px]">
      <span class="tw-text-color-text-secondary">{{ "serverVersion" | i18n }}</span>
      <span class="tw-font-mono tw-text-color-text-default">{{ serverVersion }}</span>
    </div>
  </div>

  <!-- Beta features -->
  <div
    *appRoleScope="'BETA_ACCESS'"
    class="tw-flex tw-flex-col tw-gap-4 tw-rounded-xl tw-bg-color-surface-card tw-p-5 tw-shadow-elevation-card"
  >
    <div class="tw-flex tw-items-center tw-gap-2">
      <p
        class="tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
      >
        {{ "betaFeatures" | i18n }}
      </p>
      <span
        class="tw-rounded-full tw-bg-color-status-info-bg tw-px-2 tw-py-0.5 tw-text-[9px] tw-font-semibold tw-text-color-status-info-text"
        >{{ "beta" | i18n }}</span
      >
    </div>

    <app-keychain></app-keychain>

    <div class="tw-flex tw-flex-col tw-gap-2">
      <label for="plugin-config" class="tw-text-[13px] tw-text-color-text-default">
        {{ "pluginConfig" | i18n }}
      </label>
      <textarea
        name="plugin-config"
        id="plugin-config"
        class="tw-w-full tw-rounded-xl tw-border-none tw-bg-color-surface-input tw-p-3 tw-font-mono tw-text-[12px] tw-text-color-text-default tw-outline-none focus:tw-shadow-elevation-input-focus"
        style="height: 200px"
        [formControl]="formControl"
      ></textarea>
      <app-gloss-button
        class="md:tw-block md:tw-w-full"
        [options]="{
          text: 'save' | i18n,
          type: 'submit',
          fullClass:
            'tw-h-9 tw-w-auto tw-px-5 tw-rounded-xl tw-border-none tw-bg-color-action-primary tw-shadow-elevation-card tw-text-color-text-on-action md:tw-h-11 md:tw-w-full',
          ghostDisabled: true,
          ghostShadow: true,
          isEnabled: true,
          onClick: savePlugin.bind(this),
        }"
      ></app-gloss-button>
    </div>
  </div>

  <!-- Danger zone -->
  <div
    class="tw-flex tw-flex-col tw-gap-4 tw-rounded-xl tw-bg-color-surface-card tw-p-5 tw-shadow-elevation-card"
  >
    <p
      class="tw-m-0 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wider tw-text-color-text-tertiary"
    >
      {{ "dangerZone" | i18n }}
    </p>
    <app-callout body="dangerZoneCallout"></app-callout>

    <div class="tw-flex tw-flex-col tw-gap-4">
      <ng-container *ngFor="let item of contextList">
        <ng-container
          *ngTemplateOutlet="
            advancedFeaturesButtons;
            context: {
              roleScope: item.roleScope,
              buttonText: item.buttonText,
              description: item.description,
              separator: item.separator,
              buttonOptions: item.buttonOptions,
            }
          "
        >
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template
  #advancedFeaturesButtons
  let-roleScope="roleScope"
  let-buttonText="buttonText"
  let-description="description"
  let-separator="separator"
  let-buttonOptions="buttonOptions"
>
  <div
    *appRoleScope="roleScope"
    class="tw-flex tw-items-center tw-justify-between tw-gap-4 md:tw-flex-col md:tw-items-stretch md:tw-gap-2"
    [ngClass]="{
      '[&:not(:first-child)]:tw-border-0 [&:not(:first-child)]:tw-border-t [&:not(:first-child)]:tw-border-solid [&:not(:first-child)]:tw-border-color-border-subtle [&:not(:first-child)]:tw-pt-4':
        separator,
    }"
  >
    <div class="tw-flex tw-flex-col tw-gap-0.5">
      <div class="tw-text-[13px] tw-text-color-text-default">{{ buttonText | i18n }}</div>
      <div class="tw-text-[12px] tw-text-color-text-secondary">{{ description | i18n }}</div>
    </div>
    <app-gloss-button
      class="tw-shrink-0 md:tw-block md:tw-w-full"
      [options]="buttonOptions"
    ></app-gloss-button>
  </div>
</ng-template>
